import { render, staticRenderFns } from "./SettingPassword.vue?vue&type=template&id=b837ea5c&scoped=true&"
import script from "./SettingPassword.vue?vue&type=script&lang=js&"
export * from "./SettingPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b837ea5c",
  null
  
)

export default component.exports